import AxiosClient from "../AxiosClient";

// fax送信API
export const postSendFaxApi = (params) => {
  return AxiosClient.post("/api/fax/sendFax", params);
}